export const pageHeader2023Gql = `... on landingPageContent2023_pageHeader_BlockType {
  typeHandle
  pageTitle
  leadParagraph
  subtitle
}`;
